import { SUB_CATEGORY_META, SUB_CATEGORY_META_SUCCESS, SUB_CATEGORY_META_ERROR, SUB_CATEGORY_META_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SubCategoryMeta = (state = initialState, action) => {
  switch (action.type) {
    case SUB_CATEGORY_META:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUB_CATEGORY_META_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUB_CATEGORY_META_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUB_CATEGORY_META_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SubCategoryMeta;
